interface Props {
    innerText: string
}

export default function Characteristics({ innerText }: Props) {
    return (
        <div
            className='text-black [&_a]:text-red-wine [&_a]:font-bold mt-4'
            dangerouslySetInnerHTML={{ __html: innerText }}
        />
    )
}
